export interface PopoutVideoOptions {
	sourceUrl: string;
	title: string;
	isLive?: boolean;
	width?: number;
	height?: number;
	onBeforeUnload?: () => void;
}

export function openVideoPopoutWindow(options: PopoutVideoOptions): Window | null {
	const { sourceUrl, title, isLive = true, width = 1280, height = 720, onBeforeUnload } = options;
	const popoutUrl = buildPopoutUrl(sourceUrl, title, isLive);
	const popup = window.open(popoutUrl, '_blank', `width=${width},height=${height},resizable=yes`);

	if (!popup) {
		return null;
	}

	if (onBeforeUnload) {
		popup.onbeforeunload = () => {
			onBeforeUnload();
			return undefined;
		};
	}

	return popup;
}

function buildPopoutUrl(sourceUrl: string, title: string, isLive: boolean): string {
	const url = new URL('video-popout', document.baseURI);
	url.searchParams.set('playbackUrl', sourceUrl);
	url.searchParams.set('title', title);
	url.searchParams.set('isLive', String(isLive));
	return url.toString();
}
